// Recherche de compte client pour le personnel (demande du propriétaire,
// 2026-10-16) — utilisée par le portail vendeur ET la soumission en 30 s :
// par nom, prénom, courriel, organisation, ville, ADRESSE enregistrée ou
// NUMÉRO DE TÉLÉPHONE (du compte ou d'une adresse).

export const normaliseTel = (t) => (t || "").replace(/\D/g, "");

export function filtrerClients(clients, terme, max = 8) {
  const q = (terme || "").trim().toLowerCase();
  if (!q) return [];
  const qt = normaliseTel(q);
  return clients.filter((c) => {
    if (`${c.name || ""} ${c.email || ""} ${c.organization || ""} ${c.city || ""}`
        .toLowerCase().includes(q)) return true;
    if (qt.length >= 3 && normaliseTel(c.phone).includes(qt)) return true;
    return (c.addresses || []).some((a) =>
      `${a.address1 || ""} ${a.address2 || ""} ${a.city || ""} ${a.postal_code || ""} ${a.label || ""}`
        .toLowerCase().includes(q)
      || (qt.length >= 3 && normaliseTel(a.phone).includes(qt)));
  }).slice(0, max);
}

// Distance d'édition — détecte les courriels « presque pareils » (doublons)
export function distLevenshtein(a, b) {
  if (a === b) return 0;
  const m = a.length, n = b.length;
  if (!m) return n;
  if (!n) return m;
  let prev = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= m; i++) {
    const cur = [i];
    for (let j = 1; j <= n; j++) {
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    }
    prev = cur;
  }
  return prev[n];
}

// Comptes « doublons probables » : même boîte autre domaine, faute de frappe
// dans le même domaine, ou même numéro de téléphone qu'un compte existant.
export function doublonsProbables(clients, email, phone, max = 3) {
  const em = (email || "").trim().toLowerCase();
  if (!em.includes("@")) return [];
  if (clients.some((c) => (c.email || "").toLowerCase() === em)) return [];
  const [loc, dom] = em.split("@");
  const tel = normaliseTel(phone);
  return clients.filter((c) => {
    const [l2, d2] = (c.email || "").toLowerCase().split("@");
    if (loc && l2 && loc === l2 && dom !== d2) return true;
    if (dom && d2 && dom === d2 && distLevenshtein(loc, l2) <= 2) return true;
    return tel.length >= 7 && normaliseTel(c.phone) === tel;
  }).slice(0, max);
}

// L'adresse PAR DÉFAUT du compte d'abord, sinon la première (2026-10-16)
export const adressePreferee = (addresses) =>
  (addresses || []).find((a) => a.default) || (addresses || [])[0] || null;
